import { gql } from '@apollo/client';

export const PAYMENT_METHODS = gql`
  query paymentMethods {
    paymentMethods {
      id
      customerId
      card {
        last4
        expiryMonth
        expiryYear
      }
    }
  }
`;
